import React from 'react';

import {
  cancelRequestedBooking,
  getProfessionalCompleteContract,
  pharmacistActions,
  PharmacistLegendVariant,
} from '@pharmaplan/common';

import CancelContractRequestModal from '../../components/SelfService/ServiceWorkshiftDetails/CancelContractRequestModal';
import { setDialog } from '../../reducers/dialogReducer';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';
import { renderScreen, setOpen } from '../../actions/drawerActions';
import { CancelContractType, ScreenTypes } from '../../helpers/Constants';

const useLongTermProfessionalReportActions = () => {
  const dispatch = useAppDispatch();

  const openCancelContractRequestModal = (longTermContractId: string) => {
    dispatch(
      setDialog({
        heading: {
          title: strings.cancelRequest,
        },
        Component: (
          <CancelContractRequestModal
            successAction={pharmacistActions.getProfessionalCompleteContract}
            longTermContractId={longTermContractId}
            eventType={CancelContractType.professionalReport}
            getEvent={() => {
              dispatch(
                getProfessionalCompleteContract({
                  longTermContractId,
                  type: PharmacistLegendVariant.requested,
                }),
              );
            }}
          />
        ),
        maxWidth: 'lg',
        showCloseButton: true,
      }),
    );
  };

  const handleRequestCancellation = (
    { id, isAutoSyncRecord }: { id?: string; isAutoSyncRecord?: boolean },
    longTermContractId?: string,
  ) => {
    if (longTermContractId) {
      openCancelContractRequestModal(longTermContractId);
    } else {
      dispatch(cancelRequestedBooking({ id: id ?? '', isAutoSyncRecord }));
    }
  };

  const requestBooking = (
    longTermContractId: string,
    id: string,
    isAutoSyncRecord: boolean,
  ) => {
    dispatch(setOpen(true));
    dispatch(
      renderScreen({
        screenNumber: 1,
        screenType: ScreenTypes.serviceWorkshiftDetails,
        eventIds: [id],
        type: PharmacistLegendVariant.workshift,
        extraParameters: {
          isAutoSyncIDMap: { [id]: isAutoSyncRecord },
        },
      }),
    );
  };

  return { handleRequestCancellation, requestBooking };
};

export default useLongTermProfessionalReportActions;
